import request, { FetchError } from '@/services/request';
import getError from '@/services/getError';

export async function getContacts(id, year) {
  try {
    if (!id) return;
    else if (!id) throw new Error('id cannot be null');
    const res = await request({
      endpoint: `/api/${year}/contact/${id ? id : ''}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error getContacts');
    }
  } catch (e) {
    console.error('error getContacts ' + e);
    throw new FetchError(e.response, e.body, e.message, e.status);
  }
}

/**
 * @param { {id?: number, fio: string, email: string,  position: string,workPhoneNumber: string, mobilePhoneNumber: string, orgId?: number,type: 'MAIN' | 'DIRECTOR'}} data
 * @return {Promise<{id: number, fio: string, email: string,  position: string,workPhoneNumber: string, mobilePhoneNumber: string, orgId: number,type: 'MAIN' | 'DIRECTOR'}>}
 * */
export async function updateContact(data, orgId, year) {
  try {
    const payload = [
      'id',
      'fio',
      'email',
      'position',
      'workPhoneNumber',
      'mobilePhoneNumber',
      'orgId',
      'type',
    ].reduce((acc, value) => {
      acc[value] = data[value];
      return acc;
    }, {});
    const res = await request({
      endpoint: `/api/${year}/contact/`,
      method: data.id ? 'put' : 'post',
      body: {
        ...payload,
        orgId: orgId,
      },
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error getContacts');
    }
  } catch (e) {
    console.error('error getContacts ' + e);
    throw new FetchError(e.response, e.body, e.message, e.status);
  }
}

export async function getBlockInfo(year, id) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/status/${id}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error getBlockInfo');
    }
  } catch (e) {
    console.error('error getBlockInfo' + e);
    throw new Error('error getBlockInfo' + e);
  }
}

export async function checkBlock(id, year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/checkBlock/${id}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error('error checkBlock');
    }
  } catch (e) {
    console.error('error checkBlock' + e);
    throw new Error('error checkBlock' + e);
  }
}

//block all ????
// export async function setBlock(payload = true, id, year) {
//   try {
//     if (store.getters['keycloak/getUser']?.orgID) id = store.getters['keycloak/getUser']?.orgID;
//     if (store.getters['keycloak/getFakeUser']) id = store.getters['keycloak/getFakeUser']?.id;
//     const res = await request({
//       endpoint: `/api/${year}/data/block/${id}/${payload}`,
//       method: 'put',
//     });
//     if (res.status === 200) {
//       return res.data;
//     }
//   } catch (e) {
//     throw new Error('error setBlock' + e);
//   }
// }

/**
 * @param {id, null, undefined} id orgId cannot be null
 * @param {'PAID_INTERNSHIP' , 'PAID_POSTGRADUATE' , 'PAID_ASSIST' , 'PAID_BSM' , 'INTERNSHIP' , 'POSTGRADUATE' , 'DOP_MAG' , 'BSMA'} typeBlock
 * */
export async function setBlockOneType(typeBlock, id, year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/block/${id}/${typeBlock}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    throw new Error('error setBlockOneType' + e);
  }
}

/**
 * @param {id, null, undefined} id orgId
 * @param {'PAID_INTERNSHIP' , 'PAID_POSTGRADUATE' , 'PAID_ASSIST' , 'PAID_BSM' , 'INTERNSHIP' , 'POSTGRADUATE' , 'DOP_MAG' , 'BSMA'} typeBlock
 * */
// eslint-disable-next-line no-unused-vars
export async function checkBlockOneType(typeBlock, id, year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/checkBlock/${id}/${typeBlock}`, //${id}/
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    throw new Error('error checkBlockOneType' + e);
  }
}

export const TypeBlock = [
  'PAID_INTERNSHIP',
  'PAID_POSTGRADUATE',
  'PAID_ASSIST',
  'PAID_BSM',
  'INTERNSHIP',
  'POSTGRADUATE',
  'DOP_MAG',
  'BSMA',
  'APPDEADLINE',
  'TARGET_QUOTA_BSMA',
  'TARGET_QUOTA_POSTGRADUATE',
  'TARGET_QUOTA_INTERNSHIP',
];

/**
 * @param {boolean} payload
 * @param {id, null, undefined} id orgId
 * @param {'PAID_INTERNSHIP' , 'PAID_POSTGRADUATE' , 'PAID_ASSIST' , 'PAID_BSM' , 'INTERNSHIP' , 'POSTGRADUATE' , 'DOP_MAG' , 'BSMA'} typeBlock
 * @return {Promise}
 * */
export async function changeBlockStatus(payload = true, id, typeBlock, year) {
  try {
    if (!TypeBlock.includes(typeBlock)) throw new Error(`typeBlock doesn't exist in allow values`);
    const res = await request({
      endpoint: `/api/${year}/data/${payload ? 'unblock' : 'block'}/${id}/${typeBlock}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error('error setBlock' + e);
  }
}
